import { Component, Inject, Input, OnInit, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { ToastrService } from 'ngx-toastr';
import { AssignWaveExcellenceLeverPopupComponent } from './assignwaveexcellencelever-popup/assignwaveexcellencelever-popup.component';
import { ImportExcellenceLeversPopup } from './importexcellencelevers-popup/importexcellencelevers-popup.component';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';

@Component({
    selector: 'waveexcellenceleverconfig',
    templateUrl: './waveexcellenceleverconfig.component.html',
    styleUrls: ['./waveexcellenceleverconfig.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class WaveExcellenceLeverConfigComponent implements OnInit, OnChanges {

    public dataSource = new MatTableDataSource<Wave>();

    @Input() selectedWave: Wave | undefined;
    columnsToDisplay = ['Checkbox', 'ExcellenceLever', 'ChangeLog'];

    isRemoveLeverAssignmentEnabled = false;
    removeExcellenceLeverList: number[] = []
    dialog: any;
    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private customDialog: CustomDialogService
        , public defaults: DefaultValuesService
        , private toastrService: ToastrService) { }

    ngOnInit(): void {

    }
    ngOnChanges(): void {
        this.reload()
    }

    reload() {
        if (this.selectedWave && this.selectedWave?.WaveId !== -1)
            Utils.httpGetWaveExcellenceLeverConfigurations(
                this.http,
                this.baseUrl,
                this.selectedWave!.WaveId,
                this,
                function (tthis: WaveExcellenceLeverConfigComponent, list: any) {
                    tthis.dataSource.data = list
                    tthis.removeExcellenceLeverList = [];
                    tthis.isRemoveLeverAssignmentEnabled = false;
                },
                null

            )
    }

    controlAssignedItem(ischecked: boolean, row?: any) {
        if (row) {
            if (ischecked) {
                this.removeExcellenceLeverList.push(row.ExcellenceLeverId);
                return;
            }
            const index = this.removeExcellenceLeverList.indexOf(row.ExcellenceLeverId);
            if (index !== -1) {
                this.removeExcellenceLeverList.splice(index, 1);
            }
            return;
        }
        this.removeExcellenceLeverList = ischecked
            ? (this.dataSource.data ?? []).map((x: any) => x.ExcellenceLeverId)
            : [];
    }

    isAllSelected(): boolean {
        const total = this.dataSource.data?.length ?? 0;
        return total > 0 && this.removeExcellenceLeverList.length === total;
    }

    isPartiallySelected(): boolean {
        return this.removeExcellenceLeverList.length > 0 && !this.isAllSelected();
    }

    openAssignExcellenceLeverWave() {
        this.dialog = this.dialogForm.open(AssignWaveExcellenceLeverPopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: this.selectedWave
        })
        this.afterAssigningExcellenceLevers();
    }

    openImportExcellenceLevers() {
        this.dialog = this.dialogForm.open(ImportExcellenceLeversPopup, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: this.selectedWave
        })

        this.afterAssigningExcellenceLevers();
    }

    private afterAssigningExcellenceLevers() {
        this.dialog.afterClosed().subscribe(() => {
            if (this.selectedWave?.WaveId !== -1)
                Utils.httpGetWaveExcellenceLeverConfigurations(
                    this.http,
                    this.baseUrl,
                    this.selectedWave!.WaveId,
                    this,
                    function (tthis: WaveExcellenceLeverConfigComponent, list: any) {
                        tthis.dataSource.data = list
                    },
                    null

                )
        })
    }
    confirmRemoveExcellenceLevers() {    
        this.customDialog.openConfirm({
            title: "Unassign Excellence Levers",
            message: `Do you want to unassign all selected levers?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpUnassignWaveExcellenceLeverConfigurations(
                    this.http
                    , this.baseUrl
                    , this.selectedWave?.WaveId
                    , this.removeExcellenceLeverList
                    , this
                    , function (tthis: WaveExcellenceLeverConfigComponent, result: any) {
                        if (result) {
                            tthis.reload();
                            tthis.toastrService.success(`Excellence Levers were unassigned successfully!`);
                        }
                        else
                            tthis.toastrService.error(`Excellence Levers could not be unassigned. Please, contact with administrator`);
                    },
                    null
                );
            }
        });
    }


    enableRemoveAssignmentMode() {
        this.isRemoveLeverAssignmentEnabled = !this.isRemoveLeverAssignmentEnabled;
        if (this.isRemoveLeverAssignmentEnabled)
            this.removeExcellenceLeverList = [];
    }

    onHistoryDetail(element: WaveExcellenceLeverConfig, type: string) {

        var waveExcellenceLeverConfigId = 0;

        if (element.WaveExcellenceLeverConfigId != undefined)
            waveExcellenceLeverConfigId = element.WaveExcellenceLeverConfigId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: waveExcellenceLeverConfigId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }
}
